import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const blank = (month) => ({ date: `${month}-01`, registration: '', amount: '', litres: '', reference: '', note: '' });

export const MissingSlipDialog = ({ open, onOpenChange, month, vehicles, onSaved }) => {
  const [form, setForm] = useState(blank(month));
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setForm(blank(month)); }, [open, month]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const lastDay = new Date(Number(month.slice(0, 4)), Number(month.slice(5, 7)), 0).getDate();

  const save = async () => {
    if (!form.registration.trim() || !(parseFloat(form.amount) > 0)) { toast.error('Vehicle and amount are required'); return; }
    setBusy(true);
    try {
      const token = localStorage.getItem('token') || sessionStorage.getItem('token');
      await axios.post(`${API}/fuel-tracker/verification/missing-slip`, form, { headers: { Authorization: `Bearer ${token}` } });
      toast.success('Missing slip added');
      onOpenChange(false);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || 'Could not add slip'); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="missing-slip-dialog">
        <DialogHeader>
          <DialogTitle>Add Missing Slip — {month}</DialogTitle>
          <DialogDescription>For a slip that was never captured. It's added as captured R0 and verified at the slip amount, so the variance shows.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div><Label>Date *</Label><Input type="date" min={`${month}-01`} max={`${month}-${String(lastDay).padStart(2, '0')}`} value={form.date} onChange={set('date')} data-testid="missing-slip-date" /></div>
          <div>
            <Label>Vehicle Reg *</Label>
            <Input list="missing-slip-vehicles" value={form.registration} onChange={(e) => setForm((f) => ({ ...f, registration: e.target.value.toUpperCase() }))} className="font-mono uppercase" placeholder="e.g. CFM94394" data-testid="missing-slip-reg" />
            <datalist id="missing-slip-vehicles">{vehicles.map((v) => <option key={v} value={v} />)}</datalist>
          </div>
          <div><Label>Amount (R) *</Label><Input type="number" step="0.01" value={form.amount} onChange={set('amount')} placeholder="0.00" data-testid="missing-slip-amount" /></div>
          <div><Label>Litres</Label><Input type="number" step="0.01" value={form.litres} onChange={set('litres')} placeholder="optional" data-testid="missing-slip-litres" /></div>
          <div className="col-span-2"><Label>Slip / Reference No.</Label><Input value={form.reference} onChange={set('reference')} placeholder="optional" data-testid="missing-slip-ref" /></div>
          <div className="col-span-2"><Label>Note</Label><Textarea rows={2} value={form.note} onChange={set('note')} placeholder="e.g. found in driver's cab" data-testid="missing-slip-note" /></div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>
          <Button onClick={save} disabled={busy} className="bg-rose-600 hover:bg-rose-700" data-testid="missing-slip-save">{busy ? 'Saving…' : 'Add Slip'}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
